export const HELPDESK_PHONE_DISPLAY = "+91 8331000808";
export const EMERGENCY_PHONE_DISPLAY = "+91 8331000303";
export const HELPDESK_PHONE_TEL = "+918331000808";
export const EMERGENCY_PHONE_TEL = "+918331000303";
export const WHATSAPP_NUMBER = "+918331000808";
